import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { PromotionsTable } from "@/components/promotions/promotions-table"
import { PromotionDialog } from "@/components/promotions/promotion-dialog"
import { PlusIcon } from "lucide-react"
import { PageHeader } from "@/components/shared/page-header"

export default function PromotionsPage() {
  const [searchQuery, setSearchQuery] = useState("")
  const [showAddDialog, setShowAddDialog] = useState(false)

  return (
    <div className="space-y-6">
      <PageHeader title="Promotions">
        <Input
          placeholder="Search promotions..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full sm:w-64"
        />
        <Button onClick={() => setShowAddDialog(true)} className="w-full sm:w-auto">
          <PlusIcon className="h-4 w-4 mr-2" />
          Add Promotion
        </Button>
      </PageHeader>

      <Card>
        <CardHeader>
          <CardTitle>Promotions List</CardTitle>
        </CardHeader>
        <CardContent>
          <PromotionsTable searchQuery={searchQuery} />
        </CardContent>
      </Card>

      <PromotionDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        promotion={null}
      />
    </div>
  )
}
